import { type LucideProps } from 'lucide-react'

/**
 * Graph View Icon (Custom Design)
 *
 * Hierarchical graph/org chart icon for the graph view toggle.
 * Shows a parent box (top) with two child boxes (bottom) connected
 * by clean T-junction lines, representing a hierarchy/graph structure.
 *
 * Hand-tuned design with larger boxes and proper stroke-based connections.
 */
export function GraphView({
  size = 24,
  className = '',
  ...props
}: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      {...props}
    >
      {/* Connection lines - clean T-junction */}
      <path
        d="M10 7v3M4.5 10h11M4.5 10v2.5M15.5 10v2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="miter"
        fill="none"
      />
      {/* Parent box (top, centered) - larger */}
      <rect x="5.5" y="1" width="9" height="6" rx="1.5" />
      {/* Left child box - larger */}
      <rect x="0" y="12.5" width="9" height="6" rx="1.5" />
      {/* Right child box - larger */}
      <rect x="11" y="12.5" width="9" height="6" rx="1.5" />
    </svg>
  )
}
